import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectFieldDefinitionInfoNodes } from '../../types/generated/ProjectFieldDefinitionInfoNodes';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetProjectFieldDefinitionsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  excludeSystemFields?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetProjectFieldDefinitionsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, totalFieldDefinitions?: { __typename?: 'ProjectFieldDefinitionConnection', totalCount: number } | null, fieldDefinitions?: { __typename?: 'ProjectFieldDefinitionConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectFieldDefinition', fieldType: Types.FieldTypeEnum, id: string, isDefaultField?: boolean | null, isFilterable?: boolean | null, isGroupable?: boolean | null, isSortable?: boolean | null, isSystemField: boolean, name: string, configuration?: { __typename?: 'DateFieldConfiguration', displayFormat?: Types.DisplayFormatEnum | null, displayTimezone?: boolean | null, includeTime?: boolean | null, timeFormat?: Types.TimeFormatEnum | null } | { __typename?: 'NumberFieldConfiguration', scale?: number | null } | { __typename?: 'RatingFieldConfiguration', color?: string | null, maxValue: number, style?: Types.RatingStyleEnum | null } | { __typename?: 'SelectFieldConfiguration', options: Array<{ __typename?: 'SelectOption', color?: string | null, displayName: string, id: string }> } | { __typename?: 'ToggleFieldConfiguration', color?: string | null } | { __typename?: 'UserFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean, customMembers?: Array<{ __typename?: 'CustomMember', id: string, type: Types.CustomMemberTypeEnum }> | null } | { __typename?: 'UsersFieldConfiguration', memberOptionsType: Types.MemberOptionsTypeEnum, notifyMembers: boolean, selectType: Types.MemberSelectTypeEnum, customMembers?: Array<{ __typename?: 'CustomMember', id: string, type: Types.CustomMemberTypeEnum }> | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | null } | null };


export const GetProjectFieldDefinitions = /*#__PURE__*/ gql`
    query GetProjectFieldDefinitions($projectId: ID!, $query: String, $excludeSystemFields: Boolean) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      id
      ...ProjectFieldDefinitionInfoNodes
      totalFieldDefinitions: fieldDefinitions(
        page: {first: 0}
        filters: {excludeSystemFields: $excludeSystemFields}
      ) {
        totalCount
      }
    }
  }
}
    ${ProjectFieldDefinitionInfoNodes}` as unknown as DocumentNode<GetProjectFieldDefinitionsQuery, GetProjectFieldDefinitionsQueryVariables>;

          

          export const useGetProjectFieldDefinitionsQuery = (options?:QueryHookOptions<GetProjectFieldDefinitionsQuery, GetProjectFieldDefinitionsQueryVariables>) => useQuery(GetProjectFieldDefinitions, options);

          

          export type GetProjectFieldDefinitionsQueryOptions = QueryHookOptions<GetProjectFieldDefinitionsQuery, GetProjectFieldDefinitionsQueryVariables>;

          

          export const useGetProjectFieldDefinitionsLazyQuery = (options?:LazyQueryHookOptions<GetProjectFieldDefinitionsQuery, GetProjectFieldDefinitionsQueryVariables>) => useLazyQuery(GetProjectFieldDefinitions, options);

          

          export type GetProjectFieldDefinitionsQueryResult = ReturnType<typeof useGetProjectFieldDefinitionsQuery>;

          
